import { Lock } from 'iconoir-react';
import { cloneElement, FC, ReactElement } from 'react';
import { Link, useMatch } from 'react-router-dom';

import {
  safeFormattedIntlString,
  SafeFormattedMessageWithoutSpread,
} from '@savgroup-front-common/core/formatters';
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from '@savgroup-front-common/primitive/ui/sidebar';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@savgroup-front-common/primitive/ui/tooltip';

import { MenuRowContent } from '../../../MenuRowContent/MenuRowContent';
import { MenuItem } from '../../AppBarMenu/AppBarMenu.types';

interface NavigationDrawerNavLinkProps {
  menu: MenuItem;
  onNavigate: () => void;
}

export const NavigationDrawerNavLink: FC<NavigationDrawerNavLinkProps> = ({
  menu,
  onNavigate,
}) => {
  const isActive = useMatch(menu.path);

  const icon = cloneElement(menu.icon as ReactElement<{ className?: string }>, {
    className: 'size-5',
  });

  if (menu.isDisabled) {
    return (
      <SidebarMenuItem>
        <Tooltip>
          <TooltipTrigger asChild>
            <SidebarMenuButton
              disabled
              variant="muted"
              className="h-auto gap-3 rounded-sm px-3 py-2.5 text-base font-normal"
              data-testid={`appBar_drawerMenu_${menu.dataTestId}`}
            >
              <MenuRowContent
                icon={icon}
                trailingIcon={<Lock className="size-4" />}
              >
                <SafeFormattedMessageWithoutSpread message={menu.message} />
              </MenuRowContent>
            </SidebarMenuButton>
          </TooltipTrigger>

          {menu.toolTip && (
            <TooltipContent>
              {safeFormattedIntlString(menu.toolTip)}
            </TooltipContent>
          )}
        </Tooltip>
      </SidebarMenuItem>
    );
  }

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        variant="muted"
        className="h-auto gap-3 rounded-sm px-3 py-2.5 text-base font-normal"
      >
        <Link
          to={menu.to}
          onClick={onNavigate}
          aria-current={isActive ? 'page' : undefined}
          data-testid={`appBar_drawerMenu_${menu.dataTestId}`}
        >
          <MenuRowContent icon={icon}>
            <SafeFormattedMessageWithoutSpread message={menu.message} />
          </MenuRowContent>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
